module.exports = __webpack_public_path__ + "media/images/menu/open_clusters-23f56713373a7ff9e8f3df483ff618de.jpg";